/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 assets/sg-river.glb -o src/components/River.jsx -s -T -i
Files: assets/sg-river.glb [7.96MB] > /Users/angyizhe/code/WEBGL/sg-tourism/src/components/sg-river-transformed.glb [1.36MB] (83%)
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

export default function River(props) {
  const { nodes, materials } = useGLTF("models/sg-river-transformed.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.boat.geometry}
        material={materials.SingaporeRiver}
        position={[-0.822, 0.04, 0.081]}
        rotation={[Math.PI / 2, 0, -1.218]}
        scale={0.03}
      />
    </group>
  );
}

useGLTF.preload("models/sg-river-transformed.glb");
